$(document).ready(function () {

    $(".module-style__fullsize-teaser.Text_Link_TextImageLeft .module-content-block .row.hidden-xs .col-sm-6:last-child").each(function() {
        $(this).children().wrapAll("<div class='fullsize-teaser'></div>");
    });

    $(".module-style__fullsize-teaser.Text_Link_TextImageRight .module-content-block .row.hidden-xs .col-sm-6:first-child").each(function() {
        $(this).children().wrapAll("<div class='fullsize-teaser'></div>");
    });

});